import React from "react";

const WhatsappApi = () => {
  return <div>WhatsappApi</div>;
};

export default WhatsappApi;
